// Change the version number to force update the session key
const productSessionKey = "productSkus_v1.2";


const gtcHandleize = (string) => {
    if (!string) return '';
    return string
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-') // replace non-alphanumeric characters with hyphens
        .replace(/^-+|-+$/g, ''); // remove leading and trailing hyphens
}


function createFragments(groupedProducts, colorSwatchesContainer, currentColor) {
    const fragment = new DocumentFragment();
    const colorSwatchItem = colorSwatchesContainer.querySelector('.js-color-Swatches__item');
    const colorSwatchList = colorSwatchesContainer.querySelector('.js-color-Swatches__list');
    const colorSwatchCurrentColor = colorSwatchesContainer.querySelector('[data-color-swatches-current-color]');
    const colorSwatchCurrentColorText = colorSwatchCurrentColor.dataset.colorSwatchesCurrentColor;

    groupedProducts.forEach((item) => {
        /**Cloning node and creating template for swatches to manipulate */
        const template = colorSwatchItem.cloneNode(true)

        if (currentColor === item.color) {
            template.classList.add('is-selected')
            template.querySelector('.js-color-swatch__url').removeAttribute('href');
        } else {
            template.querySelector('.js-color-swatch__url').setAttribute('href', item.url);

            template.addEventListener('mouseenter', () => {
                colorSwatchCurrentColor.innerText = item.color;
            })
            template.addEventListener('mouseleave', () => {
                colorSwatchCurrentColor.innerText = colorSwatchCurrentColorText;
            })
        }
        if (item.color) {
            template.querySelector('.js-color-swatch__url').setAttribute('title', item.color);
            template.querySelector('.js-color-Swatches__swatch').setAttribute('alt', item.color);
        }

        if (item.image) {
            template.querySelector('.js-color-Swatches__swatch').setAttribute('src', item.image);
        }

        fragment.appendChild(template)
    })

    /**Removing placeholders and adding corrct swatches */
    colorSwatchList.innerHTML = "";
    colorSwatchList.appendChild(fragment)
}

function initColorSwatches(storedProductSkusInSession) {

    const productSku = JSON.parse(document.querySelector('[data-product-json]').innerHTML).product.variants[0].sku;
    const productType = gtcHandleize(JSON.parse(document.querySelector('[data-product-json]').innerHTML).product.type);
    const productVendor = gtcHandleize(JSON.parse(document.querySelector('[data-product-json]').innerHTML).product.vendor);
    const productSkuArr = productSku.split('\\');
    let productSkuKey = productSkuArr[0];

    if (productType) {
        productSkuKey = productType + '_' + productSkuKey;
    }
    if (productVendor) {
        productSkuKey = productVendor + '_' + productSkuKey;
    }

    const colorSwatchesContainer = document.querySelector('[data-color-swatches]')
    
    /** first item in the array is the sku */
    const groupedProducts = storedProductSkusInSession[productSkuKey];

    /** secound item in the array is the colour name */
    /** Creating the colour swatches */
    createFragments(groupedProducts, colorSwatchesContainer, productSkuArr[1]);
}

function saveToSesseion(groupedProducts) {
    const mySession = window.sessionStorage;
    mySession.setItem(productSessionKey, JSON.stringify(groupedProducts));
    initColorSwatches(groupedProducts);
}

// Takes an array of objects and the property by which they should be grouped.
// Produces an object of arrays keyed by the specified property values.
//
// Provide multiple keys if your data is nested:   groupBy(dogs, 'values', 'emoji')
//
// Ex: [{id: 1, group: 'A'}, {id: 2, group: 'B'}, {id: 3, group: 'A'}],   'group'
//     =>
//     {A: [{id: 1, group: 'A'}, {id: 3, group: 'A'}], B: [{id: 2, group: 'B'}]}
const groupBy = (data, ...keys) => {
    // Ex: {values: {color: 'red'}}, ['values', 'color'] => 'red'
    const getGroupFromItem = (item, keys) => {
        return (keys.length > 1)
            ? getGroupFromItem(item[keys[0]], keys.slice(1))
            : item[keys[0]]
    }

    return data.reduce((results, item) => {
            // Get the first instance of the key by which we're grouping
            var group = getGroupFromItem(item, keys);

            // Ensure that there's an array to hold our results for this group
            results[group] = results[group] || [];

            // Add this item to the appropriate group within results
            results[group].push(item);

            // Return the updated results object to be passed into next reduce call
            return results;
        },
        // Initial value of the results object
        {}
    );
};

async function getProducts(requests) {
    Promise.all(requests).then(function (responses) {
        // Get a JSON object from each of the responses
        return Promise.all(responses.map(function (response) {
            return response.json();
        }));
    }).then(function (data) {
        // Log the data to the console
        // You would do something with both sets of data here
        const merged = [].concat.apply([], data);
        /**Group the products so they are easier to find */
        const groupedProducts = groupBy(merged, 'sku')
        /** Save the grouped products in the current session */
        saveToSesseion(groupedProducts);
    }).catch(function (error) {
        // if there's an error, log it
        console.log(error);
    });
}

async function getLimit() {
    const response = await fetch('/collections/all?view=data-limit');
    const limit = await response.json();
    const requests = []

    /**Get all available urls */
    for (let i = 1; i < (parseInt(Object.values(limit)) + 1); i++) {
        const urlFetch = fetch(`/collections/all?view=data&page=${i}`);
        requests.push(urlFetch)
    }
    /**Get all the available products from x pages */
    getProducts(requests);
}

const storedProductSkusInSession = JSON.parse(sessionStorage.getItem(productSessionKey));
// console.log(storedProductSkusInSession);
if (storedProductSkusInSession) {
    initColorSwatches(storedProductSkusInSession)
} else {
    /**Gets pagination limit, and then fetches all the available pages */
    getLimit();
}
